import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'
import domtoimage from 'dom-to-image'
import ViewDetails from '../viewConstituents'
import { RoleCode } from '../../../../constants'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isDownloading: false,
			isDetailsShown: false,
			selectedFilter: null
		}
		
		this.handleChart = this.handleChart.bind(this)
		this.handleDownload = this.handleDownload.bind(this)
	}

	handleDownload(e) {
		e.preventDefault()
		const visitorFilename = `chart_nature_employment_${moment().format('YYYYMMDDHHmmss')}`
        
		this.setState({ isDownloading: true }, () => {
			var that = this
			var node = document.getElementById('nature-employment-chart-container')
			domtoimage.toPng(node)
				.then(function (dataUrl) {
					let downloadLink = document.createElement('a')
					downloadLink.href = dataUrl
					downloadLink.download = `${visitorFilename}.png`
					document.body.appendChild(downloadLink)
					downloadLink.click()
					document.body.removeChild(downloadLink)

					that.setState({ isDownloading: false })
				})
				.catch(function (error) {
					console.error('oops, something went wrong!', error)
					that.setState({ isDownloading: false })
				})
		})
		
	}

	handleChart (data, isAdmin) {
		var that = this
		window.c3.generate({
			bindto: '#nature-employment-chart',
			data: {
				columns: data.data,
				type: 'pie',
				onclick: function(d) {
					if (isAdmin) {
						that.setState({ isDetailsShown: true, selectedFilter: d.name })
					}
				}
			},
			color: {
				pattern: data.legends
			},
			legend: {
				show: true,
				position: 'bottom'
			}
		})
	}

	render() {
		const { isDownloading, isDetailsShown, selectedFilter } = this.state
		const { dashboardData, AuthStore } = this.props
		const { user_type } = AuthStore
		const dataChart = _.has(dashboardData, 'natureEmploymentChart') ? dashboardData.natureEmploymentChart : {}
		var that = this
		const isAdmin = _.isEqual(RoleCode.SYSTEMADMIN, user_type) || _.isEqual(RoleCode.SUPERADMIN, user_type)
		setTimeout(() => {
			that.handleChart(dataChart, isAdmin)
		}, 1000)

		return (
			<React.Fragment>
				<div className="col-xl-6">
					{
						isAdmin &&
						<i 
							disabled={isDownloading}
							className='mdi mdi-image-area-close' 
							style={{ 
								position: 'absolute', 
								zIndex: 1, 
								right: 15,
								color: 'blue',
								cursor: 'pointer',
								fontSize: 18
							}} 
							onClick={this.handleDownload} 
						/>
					}
					<div className="card" id="nature-employment-chart-container">
						<div className="card-body">
							<h4 className="header-title mb-3">Nature of Employment</h4>

							<div dir="ltr">
								<div id="nature-employment-chart"></div>
							</div>
						</div>
					</div>
				</div>
				{
					isDetailsShown &&
					<ViewDetails 
						filterValue={selectedFilter}
						visible={isDetailsShown}
						onCancel={() => this.setState({ isDetailsShown: false, selectedFilter: null })}
					/>
				}
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
